import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo, useRef } from 'react';
import classNames from 'classnames/bind';
import { useOnScreen } from '@beef/utils';
import { Tab } from "../Tab";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var TabsView = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var focusedId = _ref.focusedId,
    isUpperCase = _ref.isUpperCase,
    onChange = _ref.onChange,
    onTabBlur = _ref.onTabBlur,
    onTabFocus = _ref.onTabFocus,
    tabs = _ref.tabs,
    variant = _ref.variant,
    selectedTab = _ref.selectedTab,
    noWrap = _ref.noWrap,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Tabs' : _ref$testName,
    _ref$isScrollable = _ref.isScrollable,
    isScrollable = _ref$isScrollable === void 0 ? true : _ref$isScrollable,
    isVertical = _ref.isVertical,
    outerSpaceValue = _ref.outerSpaceValue,
    onTabView = _ref.onTabView;
  var tabsRef = useRef(null);
  var isInView = useOnScreen(tabsRef);
  var isTabsHaveAppeared = useRef(true);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('tabs-wrapper', {
      'tabs-wrapper--scrollable': isScrollable
    }),
    "data-component": testName,
    "data-name": "Tabs",
    ref: tabsRef
    /* eslint-disable-next-line react/forbid-dom-props */,
    style: outerSpaceValue ? {
      paddingRight: "".concat(outerSpaceValue, "px"),
      marginRight: "-".concat(outerSpaceValue, "px")
    } : undefined
  }, /*#__PURE__*/React.createElement("ul", {
    className: cn('tabs', (_cn = {}, _defineProperty(_cn, "tabs--".concat(variant), Boolean(variant)), _defineProperty(_cn, 'tabs--vertical', isVertical), _cn))
  }, tabs.map(function (_ref2, index) {
    var _cn2;
    var id = _ref2.id,
      title = _ref2.title,
      link = _ref2.link,
      description = _ref2.description,
      customDescription = _ref2.customDescription,
      icon = _ref2.icon;
    return /*#__PURE__*/React.createElement("li", {
      className: cn('tabs__item', (_cn2 = {}, _defineProperty(_cn2, "tabs__item--".concat(variant), Boolean(variant)), _defineProperty(_cn2, "tabs__item--".concat(variant, "--vertical"), Boolean(variant) && isVertical), _defineProperty(_cn2, "tabs__item--selected-".concat(variant), selectedTab === id && variant), _defineProperty(_cn2, 'tabs__item--vertical', isVertical), _cn2)),
      "data-component": "Tab",
      key: id
    }, /*#__PURE__*/React.createElement(Tab, {
      customDescription: customDescription,
      description: description,
      icon: icon,
      id: id,
      isFirst: index === 0,
      isInView: isInView,
      isLast: index === tabs.length - 1,
      isScrollable: isScrollable,
      isTabFocus: focusedId === id,
      isTabsHaveAppeared: isTabsHaveAppeared,
      isUpperCase: isUpperCase,
      isVertical: isVertical,
      link: link,
      noWrap: noWrap,
      onBlur: onTabBlur,
      onClick: onChange,
      onFocus: onTabFocus,
      onView: onTabView,
      selected: selectedTab === id,
      tabBeforeSelected: selectedTab && +selectedTab === +id + 1 && variant === 'contour' ? +id - 1 : undefined,
      title: title,
      variant: variant
    }));
  })));
});